import React, { useContext, useState } from "react";
import styles from "./roomCard.module.css";
import LanguageContext from "../../context/context";
import data from "./roomCardData";
import Lightbox from 'yet-another-react-lightbox'
import "yet-another-react-lightbox/styles.css"

const Card = ({ img, i, images, price }) => {
  const language = useContext(LanguageContext);
  const [toggler, setToggler] = useState(false)

  return (
    <div className={styles.item} >
      <img className={styles.image} src={img} alt="room" />

      <button className={styles.btn} type="button" onClick={() => setToggler(true)}>{data.btn[language.language]}</button>
      <Lightbox open={toggler} close={() => setToggler(false)} slides={images} />
      <div className={styles.info}>
        <h2 className={styles.price}>{data.price[price]}  &#8382;</h2>
        <h2>{data.text[language.language][i]}</h2>
      </div>
    </div >)
}

const RoomCard = () => {
  return (
    <div className={styles.container}>
      {data.images.map((image, index) => {
        const imgs = data.gallery[index].map(el => {
          return { src: el }
        })
        return < Card key={index} img={image} i={index} images={imgs} price={index} />
      })}
    </div>
  );
};

export default RoomCard;
